import React from 'react';
import { motion } from 'framer-motion';
import { Search, ClipboardList, TrendingUp } from 'lucide-react';
const steps = [{
  number: '1',
  title: 'Diagnóstico Gratuito',
  description: 'Analizamos tu presencia digital, tu competencia local y tus oportunidades de crecimiento.',
  icon: Search
}, {
  number: '2',
  title: 'Plan Quirúrgico',
  description: 'Diseñamos una estrategia personalizada de SEO local, ads y retención para tu taller.',
  icon: ClipboardList
}, {
  number: '3',
  title: 'Resultados Medibles',
  description: 'Ejecutamos, optimizamos y te mostramos exactamente cuántos clientes nuevos llegan cada semana.',
  icon: TrendingUp
}];
export function ProcessSection() {
  return <section className="py-24 bg-pure-black border-t border-white/5 relative overflow-hidden" data-id="element-270">
      <div className="container mx-auto px-6 relative z-10" data-id="element-271">
        <div className="text-center mb-20" data-id="element-272">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-black text-electric-yellow mb-4 uppercase tracking-wide" data-id="element-273">
            Cómo Funciona
          </motion.h2>
          <motion.div initial={{
          opacity: 0,
          scaleX: 0
        }} whileInView={{
          opacity: 1,
          scaleX: 1
        }} viewport={{
          once: true
        }} className="h-1 w-24 bg-electric-yellow mx-auto rounded-full" data-id="element-274" />
        </div>

        <div className="relative max-w-5xl mx-auto" data-id="element-275">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-[4.5rem] left-[10%] right-[10%] h-[2px] border-t-2 border-dashed border-white/20 z-0" data-id="element-276" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative z-10" data-id="element-277">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.2
          }} className="flex flex-col items-center text-center" data-id="element-278">
                <div className="w-20 h-20 rounded-full bg-dark-gray border-2 border-electric-yellow flex items-center justify-center mb-6 relative" data-id="element-279">
                  <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-electric-yellow text-black font-bold flex items-center justify-center text-sm" data-id="element-280">
                    {step.number}
                  </div>
                  <step.icon className="w-8 h-8 text-electric-yellow" data-id="element-281" />
                </div>

                <h3 className="text-2xl font-bold text-white mb-4" data-id="element-282">
                  {step.title}
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-283">
                  {step.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}